module.exports = __webpack_public_path__ + "img/logo_industry.3efba1da.png";